import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import { apiSlice } from './api/apiSlice';
import accessibilityReducer from './reducers/accessibilitySlice';
import authReducer from './reducers/authSlice';
import loadingReducer from './reducers/loadingSlice';
import snackbarReducer from './reducers/snackbarSlice';
import viewerReducer from './reducers/viewerSlice';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    viewer: viewerReducer,
    snackbar: snackbarReducer,
    loading: loadingReducer,
    theme: accessibilityReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // TODO: use Project and Inspection (cache) Manager instead of this!
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/FLUSH',
          'persist/REGISTER',
          'persist/PURGE',
          'viewer/loadProject',
          'viewer/setInspection',
        ],
        ignoredPaths: ['viewer.project', 'viewer.inspection'],
      },
    }).concat(apiSlice.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
